import { Box, TextField } from "@mui/material";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";

type FeatureFlagFormValues = {
  key: string;
  percentage: number;
  description: string;
};

export const FeatureFlagCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm<FeatureFlagFormValues>({
    defaultValues: {
      key: "",
      percentage: 0,
      description: "",
    },
  });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box component="form" sx={{ display: "flex", flexDirection: "column" }} autoComplete="off">
        <TextField
          {...register("key", {
            required: "Key is required",
            pattern: {
              value: /^[A-Z][A-Z0-9_]*$/,
              message: "Key must be UPPER_SNAKE_CASE (A–Z, 0–9, underscore; starting with a letter)",
            },
          })}
          error={!!errors?.key}
          helperText={errors?.key?.message?.toString()}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Key"
          name="key"
          placeholder="FEATURE_PUSH"
        />

        <TextField
          {...register("percentage", {
            required: "Percentage is required",
            valueAsNumber: true,
            min: { value: 0, message: "Minimum is 0" },
            max: { value: 100, message: "Maximum is 100" },
          })}
          error={!!errors?.percentage}
          helperText={errors?.percentage?.message?.toString() ?? "0 = off, 100 = on for everyone"}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Rollout Percentage"
          name="percentage"
          inputProps={{ min: 0, max: 100, step: 1 }}
        />

        <TextField
          {...register("description", {
            maxLength: { value: 500, message: "Description is too long (max 500)" },
          })}
          error={!!errors?.description}
          helperText={errors?.description?.message?.toString()}
          margin="normal"
          fullWidth
          multiline
          minRows={2}
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Description"
          name="description"
        />
      </Box>
    </Create>
  );
};
